import { Checkmark } from '@/components/Checkmark';
import { LogoVariant } from '@/components/LogoVariant';
import classnames from '@/utilities/classnames';
import React from 'react';

export interface CheckboxProps {
  logo?: LogoVariant;
  htmlId: string;
  value: string | number | boolean;
  label: CheckboxLabelProps;
  ariaLabel?: string;
  checked: boolean;
  data?: any;
  onChange: (
    value: string | number | boolean,
    checked: boolean,
    data?: object
  ) => void;
}

export interface CheckboxLabelProps {
  htmlId?: string;
  text: string;
  imgPath?: string;
}

export const Checkbox: React.FC<React.PropsWithChildren<CheckboxProps>> = ({
  value,
  htmlId,
  checked,
  data = {},
  label,
  ariaLabel,
  onChange,
}) => {
  return (
    <div
      className={classnames('Checkbox Checkbox--default', {
        'Checkbox--checked': checked,
      })}
    >
      <input
        id={htmlId}
        type="checkbox"
        checked={checked}
        className="Checkbox__input"
        onChange={() => onChange(value, checked, data)}
      />
      <label
        htmlFor={htmlId}
        className="Checkbox__label"
        tabIndex={0}
        aria-label={ariaLabel}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            onChange(value, checked, data);
          }
        }}
      >
        <Checkmark checked={checked} />
        {label.text}
      </label>
    </div>
  );
};
